export default {"src":"/_next/static/media/moonriver.275d190a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};